import React, { JSX } from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  children: JSX.Element;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  // Lógica de autenticação: no exemplo, assume-se que o usuário NÃO está autenticado.
  const isAuthenticated = true; // Este valor pode ser substituído por uma verificação real (ex.: token, context, etc.)

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default ProtectedRoute;
